import { createTheme, responsiveFontSizes } from "@mui/material";

import getTypography from "./typography";
import getBreakpoints from "./breakpoints";
import getPalette from "./color";

const theme = responsiveFontSizes(
    createTheme({
        spacing: 4,
        palette: getPalette(),
        typography: getTypography(),
        breakpoints: getBreakpoints(),
    })
);

export default theme;
